import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Consultation',
  description: 'Tell us about your project and schedule a free walkthrough.'
}, {
  number: '02',
  title: 'Proposal',
  description: 'Receive a detailed, transparent quote with a clear timeline.'
}, {
  number: '03',
  title: 'Build / Paint',
  description: 'Our expert crew gets to work — clean, efficient, and on schedule.'
}, {
  number: '04',
  title: 'Final Walkthrough',
  description: 'We walk through every detail together before the job is done.'
}];
export function Process() {
  return <section className="py-20 md:py-32 bg-warmGray" data-id="element-140">
      <div className="container mx-auto px-4 md:px-6" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 md:mb-24" data-id="element-142">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-charcoal tracking-tight mb-4" data-id="element-143">
            Our Simple Process
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full" data-id="element-144" />
        </motion.div>

        <div className="relative max-w-5xl mx-auto" data-id="element-145">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-charcoal/10" data-id="element-146" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6 relative z-10" data-id="element-147">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex flex-col items-center text-center relative" data-id="element-148">
                {/* Connecting Line (Mobile) */}
                {index !== steps.length - 1 && <div className="md:hidden absolute top-16 bottom-[-40px] left-1/2 w-0.5 bg-charcoal/10 -translate-x-1/2 -z-10" data-id="element-149" />}

                <div className="w-16 h-16 rounded-full bg-gold text-white flex items-center justify-center font-heading font-bold text-xl mb-6 shadow-lg border-4 border-warmGray" data-id="element-150">
                  {step.number}
                </div>
                <h3 className="font-heading text-xl font-bold text-charcoal mb-3 bg-warmGray px-2" data-id="element-151">
                  {step.title}
                </h3>
                <p className="text-charcoal/70 text-base leading-relaxed max-w-[250px]" data-id="element-152">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}